export const pageTitle = 'Finances | Pineapple Labs';
